import React, { useEffect, useState } from "react";
import { 
    DefaultButton, 
    Dropdown,
    IDropdownOption
 } from "@fluentui/react";
import Select, { OptionTypeBase, components } from "react-select";
import LineChart from "./LineChart";
import ClusteredBarChart from "./ClusteredBarChart";
import BarChart from "./BarChart";
import { 
    FaRegCalendarAlt,
    FaRegClock,
 } from "react-icons/fa";
import moment from "moment";

const INTERVALS = [1, 2, 3, 4, 6, 8, 12];
const DURATION = ['Week', 'Month', 'Year'];

const OrderVisualization = ({data}:any) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [interval, setInterval] = useState<OptionTypeBase>({ label: INTERVALS[0], value: INTERVALS[0] });
    const [duration, setDuration] = useState<OptionTypeBase>({ label: DURATION[0], value: DURATION[0] });
    
    const Control = ({ children, ...props }:any) => {
        return (
        <components.Control {...props}>
            <FaRegClock className={"select-icon"}/>Interval <span className="select-value">Every {interval.value} Hour{parseInt(interval.value)>1&&"s"}</span>{children[1]}
        </components.Control>
        );
    };
    const Control2 = ({ children, ...props }:any) => {
        return (
        <components.Control {...props}>
            <FaRegCalendarAlt className={"select-icon"}/>Duration: <span className="select-value">This {duration.value}</span>{children[1]}
        </components.Control>
        );
    };

    const chartData:any = {
        nominationWeek: [
            { timeNo: '2025-02-01T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-02T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-03T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-04T00:00:00.0000000Z', value: 4 },
            { timeNo: '2025-02-05T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-06T00:00:00.0000000Z', value: 1 },
            { timeNo: '2025-02-07T00:00:00.0000000Z', value: 3 },
        ],
        nominationMonth: [
            { timeNo: '2025-02-01T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-02T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-03T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-04T00:00:00.0000000Z', value: 4 },
            { timeNo: '2025-02-05T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-06T00:00:00.0000000Z', value: 1 },
            { timeNo: '2025-02-07T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-08T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-09T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-10T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-11T00:00:00.0000000Z', value: 4 },
            { timeNo: '2025-02-12T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-13T00:00:00.0000000Z', value: 5 },
            { timeNo: '2025-02-14T00:00:00.0000000Z', value: 6 },
            { timeNo: '2025-02-15T00:00:00.0000000Z', value: 5 },
            { timeNo: '2025-02-16T00:00:00.0000000Z', value: 5 },
            { timeNo: '2025-02-17T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-18T00:00:00.0000000Z', value: 1 },
            { timeNo: '2025-02-19T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-20T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-21T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-22T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-23T00:00:00.0000000Z', value: 7 },
            { timeNo: '2025-02-24T00:00:00.0000000Z', value: 7 },
            { timeNo: '2025-02-25T00:00:00.0000000Z', value: 4 },
            { timeNo: '2025-02-26T00:00:00.0000000Z', value: 2 },
            { timeNo: '2025-02-27T00:00:00.0000000Z', value: 3 },
            { timeNo: '2025-02-28T00:00:00.0000000Z', value: 3 },
        ],
        nominationYear: [
            { timeNo: '2025-01-01T00:00:00.0000000Z', value: 70 },
            { timeNo: '2025-02-01T00:00:00.0000000Z', value: 62 },
            { timeNo: '2025-03-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-04-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-05-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-06-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-07-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-08-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-09-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-10-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-11-01T00:00:00.0000000Z', value: 0 },
            { timeNo: '2025-12-01T00:00:00.0000000Z', value: 0 },
        ],
    }

    const barChartYears:any={
        week:[
            '2025-02-01T00:00:00.0000000Z',
            '2025-02-02T00:00:00.0000000Z',
            '2025-02-03T00:00:00.0000000Z',
            '2025-02-04T00:00:00.0000000Z',
            '2025-02-05T00:00:00.0000000Z',
            '2025-02-06T00:00:00.0000000Z',
            '2025-02-07T00:00:00.0000000Z',
        ],
        month: [
            '2025-02-01T00:00:00.0000000Z',
            '2025-02-02T00:00:00.0000000Z', 
            '2025-02-03T00:00:00.0000000Z', 
            '2025-02-04T00:00:00.0000000Z', 
            '2025-02-05T00:00:00.0000000Z',
            '2025-02-06T00:00:00.0000000Z', 
            '2025-02-07T00:00:00.0000000Z', 
            '2025-02-08T00:00:00.0000000Z',
            '2025-02-09T00:00:00.0000000Z', 
            '2025-02-10T00:00:00.0000000Z', 
            '2025-02-11T00:00:00.0000000Z', 
            '2025-02-12T00:00:00.0000000Z',
            '2025-02-13T00:00:00.0000000Z',
            '2025-02-14T00:00:00.0000000Z', 
            '2025-02-15T00:00:00.0000000Z', 
            '2025-02-16T00:00:00.0000000Z', 
            '2025-02-17T00:00:00.0000000Z',
            '2025-02-18T00:00:00.0000000Z', 
            '2025-02-19T00:00:00.0000000Z', 
            '2025-02-20T00:00:00.0000000Z', 
            '2025-02-21T00:00:00.0000000Z', 
            '2025-02-22T00:00:00.0000000Z', 
            '2025-02-23T00:00:00.0000000Z',
            '2025-02-24T00:00:00.0000000Z', 
            '2025-02-25T00:00:00.0000000Z', 
            '2025-02-26T00:00:00.0000000Z', 
            '2025-02-27T00:00:00.0000000Z', 
            '2025-02-28T00:00:00.0000000Z', 
        ],
        year: [
            '2025-01-01T00:00:00.0000000Z',
            '2025-02-01T00:00:00.0000000Z',
            '2025-03-01T00:00:00.0000000Z',
            '2025-04-01T00:00:00.0000000Z',
            '2025-05-01T00:00:00.0000000Z',
            '2025-06-01T00:00:00.0000000Z',
            '2025-07-01T00:00:00.0000000Z',
            '2025-08-01T00:00:00.0000000Z',
            '2025-09-01T00:00:00.0000000Z',
            '2025-10-01T00:00:00.0000000Z',
            '2025-11-01T00:00:00.0000000Z',
            '2025-12-01T00:00:00.0000000Z',
        ],
    }

    const barChartData:any = {
        ordersWeek: [
            { data:[2000,3800,2200,5900,5500,2200,3000], group:'apeccharts-axis-0', name: 'Delivered'},
            { data:[3000,2000,5300,2200,3000,2100,2000], group:'apeccharts-axis-0', name: 'In-Progress'},
            { data:[2000,2100,2200,2200,3000,2200,5700], group:'apeccharts-axis-0', name: 'Cancelled'},
        ],
        ordersMonth: [
            { data:[2000,3800,2200,5900,5500,2200,3000,2000,3800,2200,5900,5500,2200,3000,2000,3800,2200,5900,5500,2200,3000,2000,3800,2200,5900,5500,2200,3000], group:'apeccharts-axis-0', name: 'Delivered'},
            { data:[3000,2000,5300,2200,3000,2100,2000,3000,2000,5300,2200,3000,2100,2000,3000,2000,5300,2200,3000,2100,2000,3000,2000,5300,2200,3000,2100,2000], group:'apeccharts-axis-0', name: 'In-Progress'},
            { data:[2000,2100,2200,2200,3000,2200,5700,2000,2100,2200,2200,3000,2200,5700,2000,2100,2200,2200,3000,2200,5700,2000,2100,2200,2200,3000,2200,5700], group:'apeccharts-axis-0', name: 'Cancelled'},
        ],
        ordersYear: [
            { data:[20000,30800,20200,59000,50500,20200,30000,20200,59000,50500,20200,30000], group:'apeccharts-axis-0', name: 'Delivered'},
            { data:[30000,20000,50300,22000,30000,20100,20000,20000,50300,20000,50300,22000], group:'apeccharts-axis-0', name: 'In-Progress'},
            { data:[20000,20100,20200,20200,30000,22000,57000,20200,20200,30000,22000,57000], group:'apeccharts-axis-0', name: 'Cancelled'},
        ],
    }
    

    const [selectedChart, setSelectedChart] = useState(chartData?.nominationWeek);
    const [selectedLabel, setSelectedLabel] = useState(barChartYears?.week);
    const [selectedChart2, setSelectedChart2] = useState(barChartData?.ordersWeek);

    useEffect(()=>{
        if(selectedTab===0){
            if(duration.label==="Week"){
                setSelectedChart(chartData?.nominationWeek);
            }else if(duration.label==="Month"){
                setSelectedChart(chartData?.nominationMonth);
            }else{
                setSelectedChart(chartData?.nominationYear);
            }
        }else{
            if(duration.label==="Week"){
                setSelectedChart2(barChartData?.ordersWeek);
                setSelectedLabel(barChartYears?.week);
            }else if(duration.label==="Month"){
                setSelectedChart2(barChartData?.ordersMonth);
                setSelectedLabel(barChartYears?.month);
            }else{
                setSelectedChart2(barChartData?.ordersYear);
                setSelectedLabel(barChartYears?.year);
            }
        }
    },[selectedTab, duration])

    return (
        <div className="visualization-card">
            <div className="header">
                <h3>Order Visualization</h3>
                <div className="tabs">
                    <DefaultButton className={selectedTab===0?"active-tab":"tab"} onClick={()=>setSelectedTab(0)}>Nomination</DefaultButton>
                    {/* <DefaultButton className={selectedTab===1?"active-tab":"tab"} onClick={()=>setSelectedTab(1)}>Throughput</DefaultButton> */}
                    <DefaultButton className={selectedTab===2?"active-tab":"tab"} onClick={()=>setSelectedTab(2)}>Orders</DefaultButton>
                    {/* <DefaultButton className={selectedTab===3?"active-tab":"tab"} onClick={()=>setSelectedTab(3)}>Custom</DefaultButton> */}
                </div>
            </div>
             <div className="d-flex gap" style={{marginTop:24}}>
                <div className="d-flex justify-content-between align-items-center gap text-base">
                    <Select
                        className="text-base interval-select"
                        value={duration}
                        options={DURATION.map(
                            item => ({ label: item, value: item })
                        )}
                        components={{ Control:Control2 }}
                        onChange={(e) => setDuration(e)}
                    />
                </div>
                {/* <div className="d-flex justify-content-between align-items-center gap text-base mx-2">
                    <Select
                        className="text-base interval-select"
                        value={interval}
                        options={INTERVALS.map(
                            item => ({ label: item, value: item })
                        )}
                        components={{ Control }}
                        onChange={(e) => setInterval(e)}
                    />
                </div> */}
            </div>
            {selectedTab===0?(
                <LineChart 
                    averageName="Nominations"
                    xTitle="Dates"
                    yTitle={selectedTab===0?"Nominations":"Orders"}
                    legend={true}
                    categories={selectedChart?.map(({ timeNo }:any) => moment(new Date(timeNo)).format(duration.label!=="Year"?"MM/DD/YY":"MM/YY"))}
                    data={selectedChart?.map(({ value }:any) => value)}
                />
            ):(
                <ClusteredBarChart
                    years={selectedLabel?.map((d:any) => moment(new Date(d)).format(duration.label!=="Year"?"MM/DD/YY":"MM/YY"))}
                    series={selectedChart2}
                />
            )}
        </div>
    )
}

export default OrderVisualization;